/**
 * User-related utility functions
 */

/**
 * Format title enum value to display format
 * @param title - The title enum value (MR, MS, etc.)
 * @returns Formatted title (Mr., Ms.) or empty string if no title
 */
export const formatTitle = (title?: string): string => {
  if (!title) return '';
  switch (title) {
    case 'MR':
      return 'Mr.';
    case 'MS':
      return 'Ms.';
    default:
      return title;
  }
};

/**
 * Format full name with title
 * @param firstName - User's first name
 * @param lastName - User's last name
 * @param title - User's title enum value
 * @returns Formatted full name with title or 'N/A' if no name
 */
export const formatFullName = (firstName?: string, lastName?: string, title?: string): string => {
  const formattedTitle = formatTitle(title);
  const name = `${firstName || ''} ${lastName || ''}`.trim();
  if (formattedTitle && name) {
    return `${formattedTitle} ${name}`;
  }
  return name || 'N/A';
};
